import { SidenavService } from '../services/sidenav.service'
import { SSPA } from '../constants/sspa'
import { OverlayService } from '../services/overlay.service'
import * as Hammer from 'hammerjs'
import { CommunicationService } from '../services/communication.service'

export class LifecycleAfterViewInit {
  private sidenavService: SidenavService
  private overlayService: OverlayService
  private communicationService: CommunicationService

  constructor() {
    this.sidenavService = SidenavService.singleton()
    this.overlayService = OverlayService.singleton()
    this.communicationService = CommunicationService.singleton();
    this.onAfterViewInit()
  }

  private onAfterViewInit = () => {
    window.addEventListener('single-spa:first-mount', () => {
      const overlay: HTMLElement = window.document.querySelector(SSPA.overlay)
      if (overlay) {
        overlay.addEventListener('click', SidenavService.singleton().toggle)
        this.loadGesturesSidenav()
      }
    })

    window.addEventListener('resize', () => {
      if (window.innerWidth > SSPA.mobileWindowWidth) {
        this.overlayService.remove()
        this.sidenavService.close()
      }
    })
    this.communicationService.receiveCustomEvent('toogleSidenav', () =>
      this.sidenavService.toggle()
    )
  }

  private loadGesturesSidenav() {
    const sidenav: HTMLElement = document.querySelector(SSPA.launcherSidenav)
    const hammertime = new Hammer(sidenav)

    hammertime.on('swiperight', () => {
      this.sidenavService.close()
      this.overlayService.remove()
    })
  }
}
